export enum EventCheckbox {
  REMOVE_ALL_ALLOCATION = 0,
  DELETE_ALL_EVENT = 1,
  DELETE_COURSE = 2,
  DUPLICATE_COURSE = 3,
  EDIT_COURSE = 4,
  UPDATE_STATUS_MULTIPLE_EVENT = 5,
}
